module.exports = __webpack_public_path__ + "static/media/8.07aae4d5.jpg";